import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LoadError({ name, msg, onRetry, testid }) {
  return (
    <section className="bg-white border border-rose-200 rounded-2xl p-5 flex flex-wrap items-center gap-3" data-testid={testid}>
      <AlertTriangle className="w-5 h-5 text-rose-600" />
      <p className="flex-1 text-sm text-rose-700">{name} could not load: {msg}</p>
      <Button variant="outline" onClick={onRetry} data-testid={`${testid}-retry`}>Try again</Button>
    </section>
  );
}

export const loadErrMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  return e?.response ? `server returned ${e.response.status}` : "the server did not respond";
};
